module.exports = __webpack_public_path__ + "img/nu.nu90c3898.svg";